import Navbar from '@/widgets/layout/navbar/Navbar';
import Footer from '@/widgets/layout/footer/Footer';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/global.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AppRoutes from './routes';
import { useEffect } from 'react';
import FixiedTgBtn from '@/widgets/layout/FixiedTgBtn';
import CookieBanner from '@/widgets/layout/CookieBanner';
import ScrollToTop from '@/shared/hooks/ScrollToTop';
import { observer } from 'mobx-react-lite';
import i18next from 'i18next';
import { useStore } from './app/store';

function App() {
  const { t } = useTranslation();
  const store = useStore();

  useEffect(() => {
    if (localStorage.getItem('access_token')) {
      store.checkAuth();
    }
  }, [store]);

  useEffect(() => {
    const updateLanguage = () => {
      const currentLanguage = i18next.language || 'en';
      document.documentElement.lang = currentLanguage;
    };
    updateLanguage();
    i18next.on('languageChanged', updateLanguage);
    return () => {
      i18next.off('languageChanged', updateLanguage);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
      <ScrollToTop />

        <Helmet>
          <title>{t('SEO.homePageTitle')}</title>
          <meta name='description' content={t('SEO.homePageDescription')} />
        </Helmet>
        <Navbar />
        <AppRoutes />
        <Footer />
        <FixiedTgBtn />
        <CookieBanner />
      </Router>
    </I18nextProvider>
  );
}

export default observer(App);
